"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function Export(_a) {
    var params = _a.params;
    var link = process.env.NEXT_PUBLIC_STORYBOOK_SERVICE_BACKEND_URL + "/analytics/export";
    if (params) {
        link += "?" + new URLSearchParams(params).toString();
    }
    return react_1.default.createElement("div", { className: 'storybook-analytics-export' },
        react_1.default.createElement(storybook_1.Buttons.Link, { to: link, type: 'primary', download: true }, "Exporteer naar Excel"));
}
exports.default = Export;
